import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { removeError } from "../store/fileUpload";

export const useErrorModal = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");

  const openModal = useCallback((msg) => {
    setMessage(msg);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    dispatch(removeError());
    setIsOpen(false);
    setMessage("");
  }, []);

  return {
    isOpen,
    openModal,
    closeModal,
    modalProps: {
      isOpen,
      onClose: closeModal,
      message,
    },
  };
};
